import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

type LinkByNameMode = 'exact' | 'insensitive' | 'normalized';

interface LinkByNameParams {
  patientId?: string;
  mode: LinkByNameMode;
}

interface LinkByNameResponse {
  success: boolean;
  mode: string;
  updated: number;
  skipped: number;
  total: number;
}

export function useLinkByName() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ patientId, mode }: LinkByNameParams): Promise<LinkByNameResponse> => {
      console.log(`🔗 Linking by name (${mode})...`);

      const { data, error } = await supabase.functions.invoke("link-subcategories-by-name", {
        body: { patient_id: patientId ?? null, mode },
      });

      if (error) {
        console.error("❌ Error linking by name:", error);
        throw error;
      }

      console.log("✅ Link by name completed:", data);
      return data as LinkByNameResponse;
    },
    onSuccess: (data, variables) => {
      if (variables.patientId) {
        queryClient.invalidateQueries({ queryKey: ["lab-results", variables.patientId] });
        queryClient.invalidateQueries({ queryKey: ["patient", variables.patientId] });
      }
      queryClient.invalidateQueries({ queryKey: ["lab-subcategories"] });

      if (data.updated > 0) {
        toast.success(
          `✅ Modo ${data.mode}: ${data.updated} resultados vinculados, ${data.skipped} já estavam corretos`
        );
      } else {
        toast.info(`ℹ️ Nenhum resultado precisou ser atualizado (${data.mode})`);
      }
    },
    onError: (error: any) => {
      console.error("❌ Mutation error:", error);
      toast.error("Falha ao associar por nome. Tente novamente.");
    },
  });
}
